import React from 'react';
import { Row, Col, Form } from 'react-bootstrap'; 
import { FULLY_LOADED, UNLOADED } from '../../../store/actions/platforms/platformActions';

function BandField({
  band,
  fullyLoadedCost, 
  unloadedCost, 
  viewOnly, 
  onInputChange
}) {
  return (
    <Row>
      <Col xs={1} sm={1} md={1} lg={1} xl={1}>
        Band { band.band_name }
      </Col>
      <Col xs={3} sm={3} md={3} lg={3} xl={3}>
        <Form.Group controlId={band.id} className="custom-form-group">
          <Form.Control type="number" 
            step="0.01" 
            defaultValue={fullyLoadedCost} 
            readOnly={viewOnly} 
            placeholder="Enter Cost Value"  
            costingType="fully-loaded"
            onChange={(e) => onInputChange(e, FULLY_LOADED)} 
            required/>
            <span className='required-field'> * </span>
        </Form.Group>
      </Col>
      <Col xs={3} sm={3} md={3} lg={3} xl={3}>
        <Form.Group controlId={band.id} className="custom-form-group">
          <Form.Control type="number" 
            step="0.01" 
            defaultValue={unloadedCost} 
            readOnly={viewOnly} 
            placeholder="Enter Cost Value" 
            onChange={(e) => onInputChange(e, UNLOADED)} 
            required/>
            <span className='required-field'> * </span>
        </Form.Group>
      </Col>
    </Row>
  )
}

export default BandField
